<section class="container-fluid p-4 bg-white" [ngClass]="{'bg-white' : isMobile }">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <div class="border-bottom d-lg-flex align-items-center justify-content-between mb-3">
        <div class="col-4 col-lg-6 mb-3 mb-lg-0">
          <h1 *ngIf="!isMobile" class="mb-0 h2 fw-bold">Results Database</h1>
        </div>
        <div class="col-3 col-lg-5 mb-2 mb-lg-0" [ngClass]="{ 'w-100': isMobile }">
          <div class="w-100 d-flex">
            <div class="col-2 col-lg-2 mb-2 mb-lg-0 mr-5">
              <div class="form-container">
                <div class="form-row">
                  <i [routerLink]="['/results-database-filter']" class="fa-solid fa-solid-filter fa-filter" #filterIcon></i>
                </div>
                <div class="filters" [ngClass]="{'d-none' : isMobile}" (click)="toggleFilter()" #filterContainer>
                  Filters
                </div>
              </div>
            </div>
            <div class="position-relative col-lg-8 col-md-10 col-8 justify-content-between ml-2">
              <app-generic-search
                placeholder="Search Test"
                [selectedResult]="selectedResult"
                (searchChanged)="handleSearch($event)"
              />

              <div class="position-absolute z-index-9 w-100" *ngIf="!isMobile">
                <ul *ngIf="isSelectResultsOpened" class="form-control z-index-9 mt-2 custom-rounded bg-white overflow-auto shadow">
                  <div *ngFor="let result of searchResults" class="cursor-pointer">
                    <div (click)="selectTest(result.quizName)" class="d-flex align-items-center gap-2">
                      <div class="custom-check pt-1 text-blue">&#10003;</div>
                      <div class="overline-text">{{ result.quizName }}</div>
                    </div>
                  </div>
                </ul>
              </div>
            </div>

          </div>
          <app-results-database-filter
            class="window position-absolute z-index-9"
            [ngClass]="{'d-flex flex-column justify-content-between': isMobile}"
            *ngIf="showFilter" #windowRef/>
        </div>
      </div>

    </div>

  </div>
<!--  col-2 col-lg-2 mb-2 mb-lg-0 mr-5-->
  <div class="row">
    <div class="col-lg-12 col-md-12 col-12">
      <!-- Card -->
      <div class="card rounded-3">
        <div class="p-3 row gx-5 w-100" *ngIf="!isMobile && selectedResults.selected.length">
          <div class="left-side col-6 col-lg-6 mt-1 mb-lg-0">
            <div *ngIf="!selectedResults.selected.length; else isSelected" class="user-count">
              Results({{ resultsTotalCount }})
            </div>
            <ng-template #isSelected>
              <div class="user-count me-3">selected: {{ selectedResults.selected.length }}</div>

              <div class="d-flex justify-content-between cursor-pointer"
                   (click)="openDeleteDialog(selectedResults.selected)">
                <div class="vertical-separator-line me-3"></div>

                <a class="items text-danger border border-danger rounded-pill px-3 py-1">
                  <i class="fa-regular fa-trash-can mr-1"></i>Delete</a>
              </div>
            </ng-template>
          </div>
        </div>

        <div>
          <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 cursor-pointer" *ngIf="!isMobile">

            <ng-container matColumnDef="checkBox">
              <th mat-header-cell *matHeaderCellDef>
                <div class="form-check" (click)="toggleAllRows()">
                  <input type="checkbox" [checked]="selectedResults.selected.length === results.length"
                         class="form-check-input cursor-pointer" id="checkAll">
                  <label class="form-check-label" for="checkAll"></label>
                </div>
              </th>
              <td mat-cell *matCellDef="let element">
                <div class="form-check" (click)="checkboxLabel($event,element)">
                  <input type="checkbox" [checked]=" selectedResults.selected.includes(element)"
                         class="form-check-input cursor-pointer" id="orderOne">
                  <label class="form-check-label" for="orderOne"></label>
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="quizName">
              <th mat-header-cell *matHeaderCellDef>Test Name</th>
              <td mat-cell *matCellDef="let element" (click)="goToRespondentResult(element)">{{ element.quizName }}</td>
            </ng-container>

            <ng-container matColumnDef="firstname">
              <th mat-header-cell *matHeaderCellDef>First Name</th>
              <td mat-cell *matCellDef="let element" (click)="goToRespondentResult(element)"> {{ element.firstname }}
              </td>
            </ng-container>

            <ng-container matColumnDef="lastname">
              <th mat-header-cell *matHeaderCellDef>Last Name</th>
              <td mat-cell *matCellDef="let element" (click)="goToRespondentResult(element)"> {{ element.lastname }}
              </td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>Last Name</th>
              <td mat-cell *matCellDef="let element" (click)="goToRespondentResult(element)"> {{ element.email }}</td>
            </ng-container>

            <ng-container matColumnDef="score">
              <th mat-header-cell *matHeaderCellDef>SCORE</th>
              <td mat-cell *matCellDef="let element" (click)="goToRespondentResult(element)">
                                              <span class="badge" [ngClass]="{
                           'text-success bg-light-success': element && element.testPassed && element.testEnded,
                           'text-danger bg-light-danger': element && !element.testPassed && element.testEnded,
                           'bg-secondary': !element.testEnded}">
                            {{ element.actualPercentage + "%(" + element.actualScore + "/" + element.quizTotalScore + ")" }}
                          </span>
              </td>
            </ng-container>

            <ng-container matColumnDef="endDate">
              <th mat-header-cell *matHeaderCellDef>End Date</th>
              <td mat-cell *matCellDef="let element" (click)="goToRespondentResult(element)">
                {{ element.endTime === undefined ? "-" : element.endTime | date :"dd/MM/yyyy HH:mm" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef>TIME</th>
              <td mat-cell *matCellDef="let element" (click)="goToRespondentResult(element)"><span
                class="badge text-bg-secondary">{{ element?.timeSpent ?? 0 | formatTime }}</span></td>
            </ng-container>
            <ng-container matColumnDef="delete">
              <th mat-header-cell *matHeaderCellDef></th>
              <td mat-cell *matCellDef="let element" (click)="openDeleteDialog([element])">
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <mask id="mask0_330_4956" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24"
                        height="24">
                    <rect width="24" height="24" fill="#D9D9D9"/>
                  </mask>
                  <g mask="url(#mask0_330_4956)">
                    <path
                      d="M7.30775 20.5C6.81058 20.5 6.385 20.323 6.031 19.969C5.677 19.615 5.5 19.1894 5.5 18.6923V6.00001H5.25C5.0375 6.00001 4.85942 5.92809 4.71575 5.78426C4.57192 5.64043 4.5 5.46226 4.5 5.24976C4.5 5.03709 4.57192 4.85901 4.71575 4.71551C4.85942 4.57184 5.0375 4.50001 5.25 4.50001H9C9 4.25518 9.08625 4.04651 9.25875 3.87401C9.43108 3.70168 9.63967 3.61551 9.8845 3.61551H14.1155C14.3603 3.61551 14.5689 3.70168 14.7413 3.87401C14.9138 4.04651 15 4.25518 15 4.50001H18.75C18.9625 4.50001 19.1406 4.57193 19.2843 4.71576C19.4281 4.85959 19.5 5.03776 19.5 5.25026C19.5 5.46293 19.4281 5.64101 19.2843 5.78451C19.1406 5.92818 18.9625 6.00001 18.75 6.00001H18.5V18.6923C18.5 19.1894 18.323 19.615 17.969 19.969C17.615 20.323 17.1894 20.5 16.6923 20.5H7.30775ZM17 6.00001H7V18.6923C7 18.7821 7.02883 18.8558 7.0865 18.9135C7.14417 18.9712 7.21792 19 7.30775 19H16.6923C16.7821 19 16.8558 18.9712 16.9135 18.9135C16.9712 18.8558 17 18.7821 17 18.6923V6.00001ZM10.1543 17C10.3668 17 10.5448 16.9282 10.6885 16.7845C10.832 16.6407 10.9037 16.4625 10.9037 16.25V8.75001C10.9037 8.53751 10.8318 8.35934 10.688 8.21551C10.5443 8.07184 10.3662 8.00001 10.1535 8.00001C9.941 8.00001 9.76292 8.07184 9.61925 8.21551C9.47575 8.35934 9.404 8.53751 9.404 8.75001V16.25C9.404 16.4625 9.47583 16.6407 9.6195 16.7845C9.76333 16.9282 9.94158 17 10.1543 17ZM13.8465 17C14.059 17 14.2371 16.9282 14.3807 16.7845C14.5243 16.6407 14.596 16.4625 14.596 16.25V8.75001C14.596 8.53751 14.5242 8.35934 14.3805 8.21551C14.2367 8.07184 14.0584 8.00001 13.8458 8.00001C13.6333 8.00001 13.4552 8.07184 13.3115 8.21551C13.168 8.35934 13.0962 8.53751 13.0962 8.75001V16.25C13.0962 16.4625 13.1682 16.6407 13.312 16.7845C13.4557 16.9282 13.6338 17 13.8465 17Z"
                      fill="#66656C"/>
                  </g>
                </svg>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
          </table>

          <div class="row bg-white" *ngIf="isMobile && !showSearchMobile">
            <div class="col-md-8 mx-auto bg-white">
              <div class="card p-1 shadow-none bg-white" *ngIf=" selectedResults.selected.length > 0">
                <div class="d-flex justify-content-between align-items-center">
                  <div class="mt-3">
                    <h5>Selected: {{ selectedResults.selected.length }}</h5>
                  </div>
                  <div class="d-flex align-items-center">
                    <button (click)="openDeleteDialog(selectedResults.selected)"
                            class="btn btn-sm ms-2 rounded-pill border-danger fs-6 text-danger fw-normal">
                      <i class="bi bi-trash mr-2"></i> <span>Delete</span>
                    </button>
                    <div class="form-check ml-3" (click)="toggleAllRows()">
                      <input type="checkbox" [checked]="selectedResults.selected.length === results.length"
                             class="form-check-input cursor-pointer" id="checkAllInMobile">
                      <label class="form-check-label" for="checkAllInMobile"></label>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Test Items -->
              <div class="mt-3 mr-1 bg-white" *ngFor="let element of dataSource.data">
                <div class="card mb-2 shadow-none bg-white">
                  <div class="d-flex justify-content-between align-content-center">
                    <h3 class="text-dark-blue">{{ element.quizName }}</h3>
                    <div class="d-flex justify-content-between align-items-center">
                            <span class="dropdown dropstart" (click)="$event.stopPropagation()">
                            <button class="btn-icon btn btn-ghost btn-sm rounded-circle"
                                    [matMenuTriggerFor]="beforeMenu" aria-label="Open menu">
                            <i class="fe fe-more-vertical vertical-font-size"></i>
                            </button>
                            <span class="dropdown-menu ml-2">
                              <mat-menu #beforeMenu="matMenu" xPosition="before">
                                <button class="dropdown-item p-2"
                                ><!--*ngIf="!canDelete(quiz.status)"--> <!-- (click)="openDeleteDialog(quiz?.id)"-->
                                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                                       xmlns="http://www.w3.org/2000/svg">
<mask id="mask0_330_4956" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
<rect width="24" height="24" fill="#D9D9D9"/>
</mask>
<g mask="url(#mask0_330_4956)">
<path
  d="M7.30775 20.5C6.81058 20.5 6.385 20.323 6.031 19.969C5.677 19.615 5.5 19.1894 5.5 18.6923V6.00001H5.25C5.0375 6.00001 4.85942 5.92809 4.71575 5.78426C4.57192 5.64043 4.5 5.46226 4.5 5.24976C4.5 5.03709 4.57192 4.85901 4.71575 4.71551C4.85942 4.57184 5.0375 4.50001 5.25 4.50001H9C9 4.25518 9.08625 4.04651 9.25875 3.87401C9.43108 3.70168 9.63967 3.61551 9.8845 3.61551H14.1155C14.3603 3.61551 14.5689 3.70168 14.7413 3.87401C14.9138 4.04651 15 4.25518 15 4.50001H18.75C18.9625 4.50001 19.1406 4.57193 19.2843 4.71576C19.4281 4.85959 19.5 5.03776 19.5 5.25026C19.5 5.46293 19.4281 5.64101 19.2843 5.78451C19.1406 5.92818 18.9625 6.00001 18.75 6.00001H18.5V18.6923C18.5 19.1894 18.323 19.615 17.969 19.969C17.615 20.323 17.1894 20.5 16.6923 20.5H7.30775ZM17 6.00001H7V18.6923C7 18.7821 7.02883 18.8558 7.0865 18.9135C7.14417 18.9712 7.21792 19 7.30775 19H16.6923C16.7821 19 16.8558 18.9712 16.9135 18.9135C16.9712 18.8558 17 18.7821 17 18.6923V6.00001ZM10.1543 17C10.3668 17 10.5448 16.9282 10.6885 16.7845C10.832 16.6407 10.9037 16.4625 10.9037 16.25V8.75001C10.9037 8.53751 10.8318 8.35934 10.688 8.21551C10.5443 8.07184 10.3662 8.00001 10.1535 8.00001C9.941 8.00001 9.76292 8.07184 9.61925 8.21551C9.47575 8.35934 9.404 8.53751 9.404 8.75001V16.25C9.404 16.4625 9.47583 16.6407 9.6195 16.7845C9.76333 16.9282 9.94158 17 10.1543 17ZM13.8465 17C14.059 17 14.2371 16.9282 14.3807 16.7845C14.5243 16.6407 14.596 16.4625 14.596 16.25V8.75001C14.596 8.53751 14.5242 8.35934 14.3805 8.21551C14.2367 8.07184 14.0584 8.00001 13.8458 8.00001C13.6333 8.00001 13.4552 8.07184 13.3115 8.21551C13.168 8.35934 13.0962 8.53751 13.0962 8.75001V16.25C13.0962 16.4625 13.1682 16.6407 13.312 16.7845C13.4557 16.9282 13.6338 17 13.8465 17Z"
  fill="#66656C"/>
</g>
</svg>
                                  <span class="p-lg-1" (click)="openDeleteDialog([element])">Delete</span>
                                </button>
                              </mat-menu>
                            </span>
                          </span>
                      <div class="form-check ml-3" (click)="checkboxLabel($event,element)">
                        <input type="checkbox" [checked]=" selectedResults.selected.includes(element)"
                               class="form-check-input cursor-pointer" id="orderOneMobileTime">
                        <label class="form-check-label" for="orderOneMobileTime"></label>
                      </div>

                    </div>
                  </div>
                  <p class="text-secondary">Full Name: <span
                    class="text-dark-blue">{{ element.firstname }}  {{ element.lastname }}</span></p>
                  <p class="text-secondary">Email: <span class="text-dark-blue">{{ element.email }}</span></p>
                  <p class="text-secondary">Score: <span class="badge" [ngClass]="{
                           'text-success': element && element.testPassed && element.testEnded,
                           'text-danger': element && !element.testPassed && element.testEnded,
                           'text-secondary': !element.testEnded}">
                            {{ element.actualPercentage + "%(" + element.actualScore + "/" + element.quizTotalScore + ")" }}
                          </span></p>
                  <p class="text-secondary">End Date: <span
                    class="text-dark-blue">{{ element.endTime === undefined ? "-" : element.endTime | date :"dd/MM/yyyy HH:mm" }}</span>
                  </p>
                  <p class="text-secondary">Time: <span
                    class="text-dark-blue">{{ element?.timeSpent ?? 0 | formatTime }}</span></p>

                </div>
              </div>

            </div>
          </div>
          <div class="row" *ngIf="isMobile && showSearchMobile">
            <div class="col-12 col-md-10 col-lg-8 mx-auto">
              <ul *ngIf="isSelectResultsOpened" class="list-unstyled p-2">
                <div *ngFor="let result of searchResults" class="cursor-pointer">
                  <div
                    (click)="selectTest(result.quizName)"
                    class="d-flex align-items-center gap-2 fs-3 py-2"
                  >
                    <div class="custom-check pt-1 text-primary">&#10003;</div>
                    <div class="overline-text flex-grow-1 text-truncate">{{ result.quizName }}</div>
                  </div>
                </div>
              </ul>
            </div>
          </div>


        </div>
        <!--            <span class="error"-->
        <!--                  *ngIf="(searchResults.length === 0 && searchTerm.trim()) ||-->
        <!--                   searchResults.length === 0 && results.length !== 0 || ((this.selectedTestCategoryId || this.selectedQuizId) && results.length === 0)">There are no Quiz Results</span>-->

        <div class="card-footer d-md-flex justify-content-end"
             *ngIf="resultsTotalCount > this.paginationModel.count">
          <nav aria-label="">
            <ul class="pagination  mb-0">
              <li class="page-item cursor-pointer" (click)="previousPage()"
                  [class.disabled]="paginationModel.page === 10">
                <a class="page-link mx-1 rounded"><i class="mdi mdi-chevron-left"></i></a>
              </li>
              <li class="page-item cursor-pointer"
                  (click)="goToPageNumber(paginationModel.page)">
                <a class="page-link mx-1 rounded">{{ paginationModel.page }}</a>
              </li>
              <li class="page-item cursor-pointer" (click)="nextPage()"
                  [class.disabled]="results.length < paginationModel.count">
                <a class="page-link mx-1 rounded"><i class="mdi mdi-chevron-right"></i></a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>
  </div>
</section>
